<template>
    <Button
        type="submit"
        :disabled="disabled"
        :icon="icon"
        :label="label"
        :style="style"
        :class="[
            classProp,
            {
                'linear-bg': buttonType === 'primary',
                'secondary-button': buttonType === 'secondary',
                'ghost-button': buttonType === 'ghost',
                'form-button': buttonType === 'form',
            },
        ]"
        @click="$emit('click')"
        :pt="{
            label: {
                style: `font-size: ${labelFontSize};`,
                class: `font-weight-${labelFontWeight}`,
            },
            icon: {
                style: 'font-size: 13px;',
            },
        }"
        :loading="loading"
    />
</template>

<script setup>
const props = defineProps({
    label: {
        type: String,
        required: true,
    },
    classProp: {
        type: String,
        default: '',
    },
    style: {
        type: Object,
        default: {},
    },
    icon: {
        type: String,
        default: '',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    labelFontSize: {
        type: String,
        default: '13px',
    },
    labelFontWeight: {
        type: String,
        default: '600',
    },
    buttonType: {
        type: String,
        default: 'primary',
    },
})

const emits = defineEmits(['click'])
</script>

<style scoped>
.linear-bg {
    background: linear-gradient(143deg, #9B6E2B 0%, #996923 100%);
    color: #fff;
    font-size: 14px;
    transition: all 0.3s ease-in-out;
    font-family: 'Basier Circle', sans-serif;
    font-weight: 600;
    border: none;
    border-radius: 15px;
    min-width: 150px;
    height: 44px;
    z-index: 11;
}

.linear-bg:focus {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
}

.linear-bg:hover:not(:disabled) {
    transform: translateY(-2px);
    /* box-shadow: 0 0 20px 0 rgba(102, 51, 234, 0.5); */
}

.linear-bg:disabled {
    opacity: 0.7;
    background: #e6e6e6;
    color: #5c5c5c;
    cursor: not-allowed;
}

.secondary-button {
    background: #e6e6e6;
    color: #5c5c5c;
    font-size: 14px;
    font-family: 'Basier Circle', sans-serif;
    font-weight: 500;
    border: none;
    border-radius: 18px;
    height: 44px;
    min-width: 150px;
}

.ghost-button {
    background: transparent;
    color: white;
    font-size: 18px;
    font-family: 'Basier Circle', sans-serif;
    font-weight: 600;
    border: 2px solid white;
    border-radius: 30px;
    transition: all 0.3s ease;
}

.ghost-button:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
}

.ghost-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.form-button {
    background: linear-gradient(143deg, #9B6E2B 0%, #996923 100%);
    border-radius: 8px;
    font-family: 'Basier Circle';
    font-size: 14px;
    font-weight: 600;
    border: none;
    padding: 15px;
}

.form-button:hover:not(:disabled) {
    transform: translateY(-2px);
}

.form-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
</style>
